import * as React from 'react';
import { observer } from 'mobx-react';
import { DEFAULT_FLASH_DURATION } from '~constants/Constants';

export interface IFlashMessage {
    duration?: number;
    children: React.ReactNode;
    onElapsed?(): void;
}
export const FlashMessage = observer((props: IFlashMessage) => {
    const { duration = DEFAULT_FLASH_DURATION, onElapsed, children } = props;
    const [isVisible, setIsVisible] = React.useState(true);
    let timeout: NodeJS.Timeout;
    React.useEffect(() => {
        if (isVisible) {
            timeout = setTimeout(() => {
                onElapsed?.();
                setIsVisible(false);
            }, duration);
        } else {
            clearTimeout(timeout);
        }

        return () => clearTimeout(timeout);
    }, [isVisible, duration, onElapsed]);

    return isVisible ? <> {children} </> : null;
});
